/**
 * @packageDocumentation
 * @module HackerAPI.File.Type
 */
var Type = /** @class */ (function () {
    function Type() {
    }
    Object.defineProperty(Type, "RESUME", {
        /**
         * @static
         * @constant
         * @returns
         */
        get: function () {
            return "resume";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Type, "RECEIPT", {
        /**
         * @static
         * @constant
         * @returns
         */
        get: function () {
            return "receipt";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Type, "FORM", {
        /**
         * @static
         * @constant
         * @returns
         */
        get: function () {
            return "form";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Type, "AVATAR", {
        /**
         * @static
         * @constant
         * @returns
         */
        get: function () {
            return "avatar";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Type, "OTHER", {
        /**
         * @static
         * @constant
         * @returns
         */
        get: function () {
            return "other";
        },
        enumerable: true,
        configurable: true
    });
    return Type;
}());
export default Type;
//# sourceMappingURL=type.js.map